import React from 'react';
import {View, Modal, TouchableOpacity, StyleSheet} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import CCText from '@/Atoms/CCText';
import CCButton from '@/Atoms/CCButton/CCButton';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';

interface FloatingWindowConfirmModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const FloatingWindowConfirmModal: React.FC<
  FloatingWindowConfirmModalProps
> = ({visible, onClose, onConfirm}) => {
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}>
      <View style={styles.modalOverlay}>
        <View style={styles.modalContent}>
          <View style={styles.modalHeader}>
            <View style={{flex: 1}}>
              <CCText fontWeight="bold" fontSize={FontSizes[16]}>
                Switch to Floating Window
              </CCText>
            </View>
            <TouchableOpacity onPress={onClose} style={styles.closeButton}>
              <CCText style={styles.closeButtonText}>×</CCText>
            </TouchableOpacity>
          </View>

          <View style={styles.modalBody}>
            <Icon
              name="warning"
              size={60}
              color={CCColors.Primary.Dark}
              style={{alignSelf: 'center', marginVertical: 20}}
            />
            <CCText
              fontSize={FontSizes[16]}
              color={CCColors.Black}
              style={{textAlign: 'center', marginBottom: 10}}>
              Opening in floating window will disconnect and reconnect to the
              meeting.
            </CCText>
            <CCText
              fontSize={FontSizes[14]}
              color={CCColors.Grey.Grey}
              style={{textAlign: 'center', marginBottom: 20}}>
              Are you sure you want to continue?
            </CCText>

            <View style={styles.buttonContainer}>
              <CCButton
                style={styles.actionButton}
                hoverEffect={false}
                onPress={onConfirm}>
                <CCText color={CCColors.White} fontWeight="medium">
                  Open
                </CCText>
              </CCButton>

              <CCButton
                style={[styles.actionButton, styles.secondaryButton]}
                hoverEffect={false}
                onPress={onClose}>
                <CCText color={CCColors.Primary.Dark} fontWeight="medium">
                  Cancel
                </CCText>
              </CCButton>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    width: '90%',
    maxWidth: 500,
    backgroundColor: '#fff',
    padding: 24,
    borderRadius: 10,
    elevation: 10,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  closeButton: {
    padding: 4,
  },
  closeButtonText: {
    fontSize: 32,
    fontWeight: 'bold',
    color: CCColors.Grey.Grey,
    lineHeight: 32,
  },
  modalBody: {
    alignItems: 'center',
  },
  buttonContainer: {
    width: '100%',
    gap: 12,
    marginTop: 10,
  },
  actionButton: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 8,
    width: '100%',
  },
  secondaryButton: {
    backgroundColor: CCColors.White,
    borderWidth: 1,
    borderColor: CCColors.Primary.Dark,
  },
});
